import Vue from 'vue'
import VRipple from 'v-ripple-directive'

Vue.use(VRipple)
